let adCount = 1;

SNI.Application.addModule('dynamic-bigbox', function(context) {
  const ads = context.getService('ads');

  return {
    init: () => {

      adCount++;
      let attrs = { 'data-slot-type': 'ad_block_content' };

      // allow config'd attributes override (used for Chicory on mobile recipe)
      let config = context.getConfig();
      if (config?.attrs)
        Object.assign(attrs, config.attrs);

      let adContainer = document.createElement('div');

      $(adContainer).attr(attrs);

      context.getElement().appendChild(adContainer);

      ads.updateAdSlots();
    }
  };
});
